import { useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import InputPhoneIntl from '../Form/Fields/InputPhoneIntl';
import Button from '../Form/Button';
import { faUserPlus, faUserEdit } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../../api';
import { useNavigate } from 'react-router-dom';
import { toastCreated } from '../../utils/ToastLink';

import './CreateProductModal.scss';

export default function PatientModal({ show, onClose, patient, onSave }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isEdit = !!patient?.id;

  const handleSubmit = async (data) => {
    setLoading(true);
    const method = isEdit ? 'put' : 'post';
    const url = isEdit
      ? `${API_BASE_URL}/api/v1/updatePatient/${patient.id}`
      : `${API_BASE_URL}/api/v1/createPatient`;

    try {
      const res = await axios[method](url, data, { withCredentials: true });
      if (isEdit) {
        toast.success('Patient mis à jour !');
      } else {
        toastCreated(navigate, 'Patient créé !', res.data?.id && `/patient/${res.data.id}`);
      }
      onClose();
      onSave(res.data);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erreur lors de la sauvegarde');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      id="patientModal"
      title={isEdit ? 'Modifier le patient' : 'Nouveau patient'}
      show={show}
      onClose={onClose}
      icon={isEdit ? faUserEdit : faUserPlus}
      iconBg={isEdit ? '#fff7ed' : '#f0fdf4'}
      iconColor={isEdit ? '#c2410c' : '#15803d'}
      footer={
        <Button
          isLoading={loading}
          loadingMessage="Enregistrement…"
          className="btn btn-primary w-100"
          type="submit"
          form="patientForm"
        >
          {isEdit ? 'Enregistrer les modifications' : 'Créer le patient'}
        </Button>
      }
    >
      <Form id="patientForm" onSubmit={handleSubmit} defaultValues={patient ?? {}}>

        <div className="cdm-section">
          <p className="cdm-section__label">Identité</p>
          <div className="cdm-grid-2">
            <div>
              <span className="cdm-field-label">Prénom <span className="text-danger">*</span></span>
              <InputText
                name="firstName"
                validationRules={{ required: 'Champ requis' }}
                placeholder="Prénom"
              />
            </div>
            <div>
              <span className="cdm-field-label">Nom</span>
              <InputText
                name="lastName"
                placeholder="Nom de famille"
              />
            </div>
          </div>
        </div>

        <div className="cdm-section" style={{ marginBottom: 0 }}>
          <p className="cdm-section__label">Contact</p>
          <div className="cdm-grid-2">
            <div>
              <span className="cdm-field-label">Email</span>
              <InputText
                name="email"
                validationRules={{
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Adresse email invalide',
                  },
                }}
                placeholder="email@exemple.com"
              />
            </div>
            <div>
              <span className="cdm-field-label">Téléphone</span>
              <InputPhoneIntl name="phoneNumber" />
            </div>
          </div>
        </div>

      </Form>
    </Modal>
  );
}
